import * as React from "react";
import { SVGProps } from "react";

const Monetha = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 230 208" {...props}>
    <path
      fill="#426fb6"
      d="M187.6 123.2c-15.8 0-29.6 8.6-36.9 21.4l-47.3-20.8c2.8-6.5 4.4-13.7 4.4-21.3 0-7.4-1.5-14.5-4.2-20.9l31.8-18.8c7 8 17.2 13 28.5 13 20.9 0 37.9-17 37.9-37.9S184.8 0 163.9 0 126 17 126 37.9c0 4.5.8 8.7 2.2 12.6L96.3 69.3c-9.9-12.6-25.2-20.8-42.4-20.8C24.1 48.5 0 72.6 0 102.4s24.1 53.9 53.9 53.9c17.1 0 32.3-8 42.2-20.4l49.7 21.9c-.5 2.6-.8 5.2-.8 7.9 0 23.5 19.1 42.6 42.6 42.6s42.6-19.1 42.6-42.6c.1-23.5-19-42.5-42.6-42.5zm-23.7-109c13.1 0 23.7 10.6 23.7 23.7S177 61.6 163.9 61.6 140.2 51 140.2 37.9s10.6-23.7 23.7-23.7zM53.8 142.1c-21.9 0-39.7-17.8-39.7-39.7s17.8-39.7 39.7-39.7 39.7 17.8 39.7 39.7-17.7 39.7-39.7 39.7zm133.8 52.1c-15.7 0-28.4-12.7-28.4-28.4s12.7-28.4 28.4-28.4 28.4 12.7 28.4 28.4-12.7 28.4-28.4 28.4zm-87.2 0H7.3c-4.1 0-7.3 3.2-7.3 7.1 0 3.9 3.3 7.1 7.3 7.1h93.1c4.1 0 7.3-3.2 7.3-7.1s-3.2-7.1-7.3-7.1z"
    />
  </svg>
);

export default Monetha;
